
<template>
  <div id="sections-saving-throws-pfrpg">

    <div class="row tight">
      <div class="col text-center">
        <under-text>
          <ez-modal-dice
            slot="underline"
            :name="savingThrow.name"
            :dice="`1d20+${savingThrowTotal}`">
            {{ savingThrowTotal }}
          </ez-modal-dice>
          Total
        </under-text>
      </div>
      <div class="col text-center">
        <under-text>
          <div slot="underline" class="header capitalize">{{ savingThrow.name.substring(0, 3) }}</div>
          <span class="capitalize">{{ savingThrow.name }}</span>
        </under-text>
      </div>
      <div class="col">
        <under-text class="text-center">
          <ez-modal-dice
            slot="underline"
            :name="attribute.name"
            :dice="`1d20+${$rpgv.d20.attributeBonus(attribute)}`">
            {{ $rpgv.d20.attributeBonus(attribute) }}
          </ez-modal-dice>
          <span class="capitalize">{{ savingThrow.attribute.substring(0, 3) }}</span>
        </under-text>
      </div>
      <div class="col text-center">
        <under-input v-model.number="savingThrow.base" maxlength="2">Base</under-input>
      </div>
      <div class="col text-center">
        <under-input v-model.number="savingThrow.magic" maxlength="2">Magic</under-input>
      </div>
      <div class="col text-center">
        <under-input v-model.number="savingThrow.misc" maxlength="2">Misc</under-input>
      </div>
      <div class="col-2 text-center">
        <under-input v-model.number="savingThrow.temp" maxlength="2">Temp</under-input>
      </div>
    </div>

  </div>
</template>
<script>
import UnderInput from "../shared/_UnderInput.vue";
import UnderText from "../shared/_UnderText.vue";
import EzModalDice from "@/components/shared/_VueEzModalDice.vue";

export default {
  name: "sections-saving-throws-pfrpg",
  components: {
    EzModalDice,
    UnderInput,
    UnderText
  },
  props: ["attribute", "savingThrow"],
  data() {
    return { toggleState: false };
  },
  computed: {
    savingThrowTotal() {
      let total = 0 + this.$rpgv.d20.attributeBonus(this.attribute);
      if (Number.isFinite(this.savingThrow.base))
        total += this.savingThrow.base;
      if (Number.isFinite(this.savingThrow.magic))
        total += this.savingThrow.magic;
      if (Number.isFinite(this.savingThrow.misc))
        total += this.savingThrow.misc;
      if (Number.isFinite(this.savingThrow.temp))
        total += this.savingThrow.temp;
      return total;
    }
  }
};
</script>
